<template>
  <section class="hero landing-section">
    <div class="landing-container hero__shell">
      <div class="hero__topbar">
        <router-link to="/" class="hero__brand" aria-label="AI-Tenders — на главную">
          <span class="hero__brand-name">AI-TENDERS</span>
          <span class="hero__brand-tagline">Система обработки тендеров</span>
        </router-link>
        <div class="hero__topbar-actions">
          <router-link to="/login" class="hero__login-link">Вход</router-link>
          <button
            type="button"
            class="landing-access-cta landing-access-cta--nav hero__access-btn"
            @click="emit('open-access')"
          >
            Подобрать тендеры
          </button>
        </div>
      </div>
      <div class="hero__grid">
      <div class="hero__copy">
        <p class="hero__eyebrow">Подбор закупок под вашу компанию</p>
        <h1 class="hero__title">
          Получайте каждое утро<br />
          <span class="hero__accent">подходящие тендеры под вашу компанию</span>
        </h1>
        <p class="hero__lead">
          Система мониторит закупки, отбирает релевантные лоты под ваш профиль и помогает быстрее понять, где есть смысл
          участвовать. На старте живой специалист поможет настроить подборку без лишнего шума.
        </p>
        <div class="hero__notice">
          <span class="hero__notice-icon" aria-hidden="true">◈</span>
          <p>
            Мы не продаём «ещё один сервис поиска» — помогаем получать понятную ежедневную подборку и разбирать закупки
            там, где у вас реальные шансы.
          </p>
        </div>
        <button type="button" class="landing-access-cta" @click="emit('open-access')">
          Подобрать тендеры под мою компанию
        </button>
      </div>
      <div class="hero__visual">
        <LandingHeroFacts variant="light" />
      </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import LandingHeroFacts from '@/components/landing/LandingHeroFacts.vue'

const emit = defineEmits(['open-access'])
</script>

<style scoped>
.hero {
  position: relative;
  padding: 2.4rem 0 2.9rem;
}

.hero__shell {
  position: relative;
}

.hero__topbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.75rem;
}

.hero__brand {
  flex: 0 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.12rem;
  text-decoration: none;
  color: inherit;
}

.hero__topbar-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-shrink: 0;
}

.hero__login-link {
  font-size: 0.88rem;
  font-weight: 600;
  color: #2b3e82;
  text-decoration: none;
  padding: 0.45rem 0.65rem;
  border-radius: 8px;
}

.hero__login-link:hover {
  background: rgba(43, 62, 130, 0.08);
}

.hero__access-btn {
  flex-shrink: 0;
  align-self: flex-start;
}

@media (max-width: 480px) {
  .hero__topbar {
    align-items: center;
  }

  .hero__access-btn {
    padding: 0.45rem 0.85rem;
    font-size: 0.78rem;
    min-height: 40px;
  }
}

.hero__brand-name {
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1.1;
  color: #2b3e82;
}

.hero__brand-tagline {
  font-size: 0.68rem;
  font-weight: 400;
  line-height: 1.2;
  color: #6b7280;
}

.hero__grid {
  display: grid;
  gap: 2.25rem;
  align-items: center;
}

@media (min-width: 960px) {
  .hero__grid {
    grid-template-columns: 1fr 1fr;
    gap: 3.25rem;
  }
}

.hero__eyebrow {
  margin: 0 0 0.65rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--blue-accent, #0071e3);
}

.hero__title {
  margin: 0 0 0.95rem;
  font-size: clamp(1.75rem, 4.2vw, 2.55rem);
  font-weight: 700;
  line-height: 1.12;
  color: var(--fg);
  text-align: left;
  max-width: 22ch;
}

.hero__accent {
  color: var(--blue-accent, #0071e3);
}

.hero__lead {
  margin: 0 0 1.2rem;
  color: var(--muted-strong);
  line-height: 1.62;
  font-size: 1rem;
  text-align: left;
  max-width: 58ch;
}

.hero__notice {
  display: flex;
  gap: 0.65rem;
  align-items: flex-start;
  padding: 0.85rem 1rem;
  background: var(--surface-soft);
  border: 1px solid var(--border-strong);
  border-radius: 12px;
  margin-bottom: 1.4rem;
  max-width: 36rem;
}

.hero__notice p {
  margin: 0;
  font-size: 0.84rem;
  color: var(--muted-strong);
  line-height: 1.45;
}

.hero__notice-icon {
  flex-shrink: 0;
  font-size: 0.9rem;
}

.hero__visual {
  display: flex;
  justify-content: center;
  width: 100%;
}

.hero__visual :deep(.hero-facts) {
  width: min(100%, 28rem);
}
</style>
